<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/4643.jpg" alt=""></transition></div>
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Features & Amenities" h1="ETFE Roof" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <p>The ethylene tetra fluoro ethylene roof is the darkest ETFE ever produced and provides year-round enclosed climate control which eliminates the need for stage structure wind walls.</p>
                        <Feature label="Sunlight/<br/>Shadow lines" description="Zero direct sunlight<br/>or shadow lines on<br/>stage, screens, or fans" icon="features_and_amenities/icon_sun.svg" />
                        <Feature removeMarginRight label="cost<br/>savings" description="Provides cost savings<br/>for both labor and<br/>equipment " icon="features_and_amenities/icon_price.svg" />
                        <Feature label="open<br/>sightlines" description="Opportunity to open<br/>sightlines, increasing<br/>gross potential" icon="features_and_amenities/icon_eye.svg" />
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
//TODO
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
import Feature from "@/patterns/Feature.vue";
export default {
  name: "EtfeRoof",
  components: { PageLeft, TitleContent, Feature },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style scoped>
  .image img{object-position: center bottom;}
</style>
